import React, { useState } from "react"
import { Button, Grid, Link, Typography, Radio, Tooltip } from "@material-ui/core"
import { List as MenuIcon } from "@material-ui/icons"

import useStyles, { MENU_LIST_MESSAGE_WIDTH } from "@/components/Messages/MenuListMessage/styles"
import useCustomStyles from "@/styles/custom"

import Divider from "@/components/Divider"
import ActionDialog from "@/components/ActionDialog"

import { IMessageExtraData } from "@/protocols/channel"

type MenuListMessageProps = {
	extraData: IMessageExtraData
}

export const MenuListMessageContent: React.FC<MenuListMessageProps> = (props) => {
	const {
		extraData
	} = props

	const menuListData = extraData?.["menu-list"]

	if (!menuListData?.body) {
		return null
	}

	return (
		<Grid
			container
			direction="column"
		>
			{menuListData.header && (
				<Typography
					variant="subtitle2"
					gutterBottom
				>
					{menuListData.header}
				</Typography>
			)}

			<Typography>
				{menuListData.body}
			</Typography>

			{menuListData.footer && (
				<Typography
					variant="caption"
					color="textSecondary"
				>
					{menuListData.footer}
				</Typography>
			)}
		</Grid>
	)
}

export const MenuListMessageContentFooter: React.FC<MenuListMessageProps> = (props) => {
	const {
		extraData
	} = props

	const classes = useStyles()
	const customClasses = useCustomStyles()

	const [showMenuDialogOpened, setShowMenuDialogOpened] = useState(false)

	const handleOpenShowMenuDialog = () => {
		setShowMenuDialogOpened(true)
	}

	const handleCloseShowMenuDialog = () => {
		setShowMenuDialogOpened(false)
	}

	const menuListData = extraData?.["menu-list"]

	const title = menuListData?.actionButton || ""

	return (
		<Grid>
			<Link
				component={Button}
				fullWidth
				className={`${classes.showOptionsButton} ${customClasses.inlineText}`}
				onClick={handleOpenShowMenuDialog}
			>
				<Grid
					container
					alignItems="center"
					justifyContent="center"
				>
					<MenuIcon />

					<Divider orientation="vertical" size={0.5} />

					{title}
				</Grid>
			</Link>

			<ActionDialog
				title={title.toUpperCase()}
				hideCloseButton
				onClose={handleCloseShowMenuDialog}
				openDialog={showMenuDialogOpened}
				dialogContentClassName={classes.dialogContent}
				maxWidth="sm"
				fullWidth
			>
				<Grid
					container
					spacing={2}
				>
					{menuListData?.sections?.map((section, sectionIndex) => (
						<Grid
							item
							xs={12}
							key={sectionIndex}
						>
							<Grid
								container
								direction="column"
								spacing={1}
							>
								{section.rows.map(row => (
									<Grid
										item
										xs={12}
										key={row.id}
									>
										<Grid
											container
											component={Button}
											alignItems="center"
											justifyContent="space-between"
											className={classes.menuItem}
											disabled
										>
											<Grid
												item
												className={classes.descriptionContainer}
											>
												<Typography
													variant="body1"
													color="textPrimary"
													className={classes.menuItemTitle}
												>
													{row.title}
												</Typography>

												{row.description && (
													<Typography className={classes.menuItemDescription}>
														{row.description}
													</Typography>
												)}
											</Grid>

											<Tooltip title="Somente seu destinatário pode escolher uma opção.">
												<span>
													<Radio disabled />
												</span>
											</Tooltip>
										</Grid>
									</Grid>
								))}
							</Grid>
						</Grid>
					))}

					<Grid
						item
						xs={12}
					>
						<Typography
							variant="caption"
							color="textSecondary"
						>
							Somente seu destinatário pode escolher uma opção.
						</Typography>
					</Grid>
				</Grid>
			</ActionDialog>
		</Grid>
	)
}

export const MenuListMessageContentBoxStyle: React.CSSProperties = {
	width: MENU_LIST_MESSAGE_WIDTH
}
